import './tracing';
import ReactDOM from 'react-dom/client';
import { init as initSentry } from '@sentry/react';
import './main.css';
import { setAppHeight } from '@ordr-as/umami-css/lib/js/utilities';
import App from './App';
import config from './config';
import { cleanUpSoftpayCookies } from './utils/softpay/softpayCookie';
import { Userpilot } from 'userpilot';
import { isAdyenDevice } from './utils/isAdyenDevice';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);

setAppHeight();

// todo: enable after 17.05
if (!['local', 'localQa', 'localProd'].includes(config.env) && !isAdyenDevice()) {
  initSentry({
    dsn: 'https://86f80df6a6444552b0dc2e720788777a@o347535.ingest.sentry.io/6097156',
    environment: config.env,
  });

  const userpilotToken = config.env === 'prod' ? 'NX-f4b682c9' : 'STG-NX-f4b682c9';
  Userpilot.initialize(userpilotToken);
}

cleanUpSoftpayCookies();
